"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _withMask = _interopRequireDefault(require("../TextInput/withMask"));
var _createNumberMask = _interopRequireDefault(require("./createNumberMask"));
var _Select = _interopRequireDefault(require("../Select"));
var _StyledCurrencyInput = require("./StyledCurrencyInput");
var _ykbUtils = require("ykb-utils");
var _excluded = ["decimalSymbol", "thousandsSeparatorSymbol", "includeThousandsSeparator", "allowDecimal", "allowLeadingZeroes", "decimalLimit", "size", "value", "currencyType", "editableCurrency", "className", "valuePosition", "backgroundColorType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var maskHoc = (0, _withMask.default)(_StyledCurrencyInput.StyledCurrencyInput);
var MaskedInput = maskHoc;
maskHoc.displayName = 'CurrencyInput';
var CurrencyInput = /*#__PURE__*/function (_Component) {
  function CurrencyInput(props) {
    var _this;
    (0, _classCallCheck2.default)(this, CurrencyInput);
    _this = _callSuper(this, CurrencyInput, [props]);
    (0, _defineProperty2.default)(_this, "getCurrencyValue", function (editableCurrency) {
      var list = editableCurrency && editableCurrency.currencyList ? editableCurrency.currencyList : ['TL', 'USD', 'EUR'];
      var defaultC = editableCurrency && editableCurrency.defaultCurrency ? editableCurrency.defaultCurrency : 'TL';
      var currencyIndex = list.indexOf(defaultC);
      if (defaultC && currencyIndex > 0) {
        return list.slice(currencyIndex, currencyIndex + 1)[0];
      } else {
        return list.slice(0, 1)[0];
      }
    });
    (0, _defineProperty2.default)(_this, "checkValueRange", function (value) {
      var currValue = value;
      if (typeof currValue !== 'number') {
        currValue = _this.unMask(currValue);
      }
      var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max;
      var isValid = !(currValue < min || currValue > max);
      if (isValid) return value;
      if (currValue < min) return min.toString();
      if (currValue > max) return max.toString();
    });
    (0, _defineProperty2.default)(_this, "checkPrecision", function (currValue) {
      var _this$props2 = _this.props,
        decimalLimit = _this$props2.decimalLimit,
        precision = _this$props2.precision,
        decimalSymbol = _this$props2.decimalSymbol,
        thousandsSeparatorSymbol = _this$props2.thousandsSeparatorSymbol;
      var stringValue;
      if (typeof currValue === 'number') {
        stringValue = currValue.toString().replace('.', ',');
      } else {
        stringValue = currValue.toString().replace(thousandsSeparatorSymbol, '');
        stringValue = stringValue.toString().replace(decimalSymbol, ',');
      }
      var indexOfLastDecimal = stringValue.lastIndexOf(',');
      var decimalLength = indexOfLastDecimal !== -1 ? stringValue.length - indexOfLastDecimal - 1 : 0;
      if (!(precision && !!stringValue && precision >= decimalLength)) {
        // unMask fonksiyonunun doğru çalışması için kaldırılan decimalSymbol geri eklenmeli.
        stringValue = stringValue.replace(',', decimalSymbol);
        var _unmaskedValue2 = _this.unMask(stringValue);
        if (decimalLimit < decimalLength) {
          stringValue = _this.roundValue(_unmaskedValue2, decimalLimit);
        }
        return [stringValue, _unmaskedValue2];
      }
      var finalPrecision = precision;
      if (precision > decimalLimit) finalPrecision = decimalLimit;
      if (decimalLength) {
        var zeroLength = finalPrecision - decimalLength;
        for (var i = 0; i < zeroLength; i++) {
          stringValue += '0';
        }
      } else {
        stringValue += decimalSymbol;
        for (var _i = 0; _i < finalPrecision; _i++) {
          stringValue += '0';
        }
      }
      var maskedValue = stringValue.replace(',', decimalSymbol);
      var unmaskedValue = _this.unMask(maskedValue);
      if (decimalLimit < decimalLength) {
        maskedValue = _this.roundValue(unmaskedValue, decimalLimit);
      }
      return [maskedValue, unmaskedValue];
    });
    (0, _defineProperty2.default)(_this, "roundValue", function (currValue, roundingDecimal) {
      var roundFactor = Math.pow(10, roundingDecimal);
      return (Math.round(currValue * roundFactor) / roundFactor).toString().replace('.', ',');
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (e, value, maskedValue) {
      var _this$props3 = _this.props,
        min = _this$props3.min,
        max = _this$props3.max,
        onChange = _this$props3.onChange,
        onChangeParamType = _this$props3.onChangeParamType;
      var minusCheckedValue = maskedValue === '-' ? '-' : value;
      var currValue = maskedValue;
      if (min !== undefined || max !== undefined) {
        currValue = _this.checkValueRange(maskedValue);
      }
      var _this$checkPrecision = _this.checkPrecision(currValue),
        _this$checkPrecision2 = (0, _slicedToArray2.default)(_this$checkPrecision, 2),
        stringValue = _this$checkPrecision2[0],
        unmaskedValue = _this$checkPrecision2[1];
      _this.setState({
        currencyValue: unmaskedValue,
        displayValue: stringValue
      });
      if (onChange) {
        if (onChangeParamType) onChange(e, unmaskedValue);else onChange(e, minusCheckedValue, unmaskedValue); // eski kullanıma devam et.
      }
    });
    (0, _defineProperty2.default)(_this, "handleInputChange", function (e, value, maskedValue) {
      var currentValue = e.target.value;
      var _this$props4 = _this.props,
        decimalSymbol = _this$props4.decimalSymbol,
        precision = _this$props4.precision;
      var displayFlag = false,
        splittedValue = currentValue.split(decimalSymbol);
      if (!precision && splittedValue.length === 2 && splittedValue[1].charAt(splittedValue[1].length - 1) === '0') displayFlag = true;
      if (precision && currentValue.charAt(currentValue.length - 1) !== decimalSymbol && _this.unMask(currentValue) === _this.state.currencyValue) displayFlag = true;
      if (currentValue.charAt(currentValue.length - 1) === decimalSymbol || displayFlag) {
        _this.setState({
          currencyValue: currentValue,
          displayValue: currentValue
        });
      } else {
        _this.handleChange(e, value, maskedValue);
      }
    });
    (0, _defineProperty2.default)(_this, "handleBlur", function (e) {
      var decimalSymbol = _this.props.decimalSymbol;
      var currValue = e.target.value;
      if (_this.state.displayValue) {
        if (currValue.charAt(currValue.length - 1) === decimalSymbol) {
          currValue = currValue.replace(decimalSymbol, '');
        }
        _this.handleChange(e, _this.unMask(currValue), currValue);
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(e, _this.unMask(currValue), currValue);
      }
    });
    (0, _defineProperty2.default)(_this, "unMask", function (maskedValue) {
      if (typeof maskedValue === 'number') return maskedValue;
      var _this$props5 = _this.props,
        decimalSymbol = _this$props5.decimalSymbol,
        thousandsSeparatorSymbol = _this$props5.thousandsSeparatorSymbol;
      var thousandPattern = new RegExp('\\' + thousandsSeparatorSymbol, 'g');
      var decimalPattern = new RegExp('\\' + decimalSymbol, 'g');
      var unmaskedValue = maskedValue.replace(thousandPattern, '').replace(decimalPattern, '.');
      if (isNaN(unmaskedValue) || unmaskedValue === '') return '';
      if (Number(unmaskedValue) > Number.MAX_SAFE_INTEGER) {
        unmaskedValue = _this.lastUnmaskedValue;
      }
      _this.lastUnmaskedValue = parseFloat(unmaskedValue);
      return _this.lastUnmaskedValue;
    });
    (0, _defineProperty2.default)(_this, "handleChangeSelect", function (currency) {
      _this.setState({
        selected: currency
      });
      if (_this.props.handleCurrencyTypeChange) _this.props.handleCurrencyTypeChange(currency);
    });
    (0, _defineProperty2.default)(_this, "handleKeyDown", function (e) {
      var _this$props6 = _this.props,
        precision = _this$props6.precision,
        decimalSymbol = _this$props6.decimalSymbol,
        min = _this$props6.min;
      //109 is '-' on numpad
      //189 is'-' in alphabate keybord key on chrome
      //173 is '-' in alphabate keybord key on firefox & on chrome 173 keycord is Mute On|Off
      var minusKeyCodes = [109, 189, 173];
      if (!(0, _ykbUtils.isNullOrUndefined)(min) && Math.sign(min) >= 0 && minusKeyCodes.includes(e.keyCode)) {
        e.preventDefault();
      }
      var selectionStart = e.target.selectionStart;
      var selectionEnd = e.target.selectionEnd;
      var noSelection = selectionStart == selectionEnd;

      // Disabled deleting decimal symbol When precision is higher than 0
      if (precision > 0 && noSelection) {
        var decimalPosition = e.target.value.indexOf(decimalSymbol);
        if (e.keyCode == 8 && selectionStart == decimalPosition + 1) {
          e.preventDefault();
          e.target.setSelectionRange(decimalPosition, decimalPosition);
        } else if (e.keyCode == 46 && selectionStart == decimalPosition) {
          e.preventDefault();
          e.target.setSelectionRange(selectionStart + 1, selectionStart + 1);
        }
      }
    });
    (0, _defineProperty2.default)(_this, "handleClear", function (e, value) {
      var onChange = _this.props.onChange;
      typeof onChange === 'function' && onChange(e, value, value);
    });
    var _value = props.value,
      _min = props.min,
      _max = props.max;
    var _currValue = _value !== null && _value !== void 0 ? _value : '';
    if (_min !== undefined || _max !== undefined) {
      _currValue = _this.checkValueRange(_currValue);
    }
    var _this$checkPrecision3 = _this.checkPrecision(_currValue),
      _this$checkPrecision4 = (0, _slicedToArray2.default)(_this$checkPrecision3, 2),
      _stringValue = _this$checkPrecision4[0],
      _unmaskedValue = _this$checkPrecision4[1];
    var currencyType = _this.getCurrencyValue(props.editableCurrency);
    if (props.editableCurrency && props.handleCurrencyTypeChange) {
      props.handleCurrencyTypeChange(currencyType);
    }
    _this.state = {
      currencyValue: _unmaskedValue,
      displayValue: _stringValue,
      selected: props.editableCurrency ? currencyType : ''
    };
    _this.lastUnmaskedValue = '';
    return _this;
  }
  (0, _inherits2.default)(CurrencyInput, _Component);
  return (0, _createClass2.default)(CurrencyInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps, nextState) {
      var value = nextProps.value,
        min = nextProps.min,
        max = nextProps.max;
      if ((0, _ykbUtils.isNullOrUndefined)(value)) {
        this.setState({
          currencyValue: value,
          displayValue: value
        });
        return;
      }
      if ('value' in nextProps) {
        var currValue = value;
        if (min !== undefined || max !== undefined) {
          currValue = this.checkValueRange(currValue);
        }
        var _this$checkPrecision5 = this.checkPrecision(currValue),
          _this$checkPrecision6 = (0, _slicedToArray2.default)(_this$checkPrecision5, 2),
          stringValue = _this$checkPrecision6[0],
          unmaskedValue = _this$checkPrecision6[1];
        this.setState({
          currencyValue: unmaskedValue,
          displayValue: stringValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props7 = this.props,
        decimalSymbol = _this$props7.decimalSymbol,
        thousandsSeparatorSymbol = _this$props7.thousandsSeparatorSymbol,
        includeThousandsSeparator = _this$props7.includeThousandsSeparator,
        allowDecimal = _this$props7.allowDecimal,
        allowLeadingZeroes = _this$props7.allowLeadingZeroes,
        decimalLimit = _this$props7.decimalLimit,
        size = _this$props7.size,
        value = _this$props7.value,
        currencyType = _this$props7.currencyType,
        editableCurrency = _this$props7.editableCurrency,
        className = _this$props7.className,
        valuePosition = _this$props7.valuePosition,
        backgroundColorType = _this$props7.backgroundColorType,
        rest = (0, _objectWithoutProperties2.default)(_this$props7, _excluded);
      var _this$state = this.state,
        currencyValue = _this$state.currencyValue,
        displayValue = _this$state.displayValue;
      var addon = null;
      if (editableCurrency) {
        var _editableCurrency$cur = editableCurrency.currencyList,
          currencyList = _editableCurrency$cur === void 0 ? ['TL', 'USD', 'EUR'] : _editableCurrency$cur,
          name = editableCurrency.name;
        addon = function addon() {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: "currency-dropdown"
          }, /*#__PURE__*/_react.default.createElement(_Select.default, {
            size: size,
            defaultValue: _this2.state.selected,
            name: name,
            editableCurrency: true,
            className: "editable-currency-dropdown",
            onChange: _this2.handleChangeSelect,
            backgroundColorType: backgroundColorType
          }, currencyList.map(function (item, i) {
            return /*#__PURE__*/_react.default.createElement(Option, {
              key: i,
              value: item
            }, item);
          })));
        };
      }
      var currencyMask = (0, _createNumberMask.default)({
        prefix: '',
        decimalSymbol: decimalSymbol,
        thousandsSeparatorSymbol: thousandsSeparatorSymbol,
        includeThousandsSeparator: includeThousandsSeparator,
        allowDecimal: allowDecimal,
        allowLeadingZeroes: allowLeadingZeroes,
        decimalLimit: decimalLimit
      });
      var itemValue = currencyValue;
      if (typeof currencyValue === 'number') itemValue = String(currencyValue).replace('.', decimalSymbol);
      if (1 / currencyValue == -Infinity && currencyValue == '-0') {
        itemValue = '-0';
      }
      itemValue = displayValue ? displayValue : itemValue;
      return /*#__PURE__*/_react.default.createElement(MaskedInput, (0, _extends2.default)({}, rest, {
        addonAfter: editableCurrency ? addon() : currencyType ? currencyType === 'YTL' ? 'TL' : currencyType : null,
        guide: false,
        unMask: this.unMask,
        mask: currencyMask,
        onChange: this.handleInputChange,
        onBlur: this.handleBlur,
        value: itemValue,
        valuePosition: valuePosition,
        onKeyDown: this.handleKeyDown,
        backgroundColorType: backgroundColorType,
        handleClear: this.handleClear,
        size: size
      }));
    }
  }]);
}(_react.Component);
CurrencyInput.displayName = 'CurrencyInput';
CurrencyInput.propTypes = {
  decimalSymbol: _propTypes.default.string,
  thousandsSeparatorSymbol: _propTypes.default.string,
  includeThousandsSeparator: _propTypes.default.bool,
  allowDecimal: _propTypes.default.bool,
  allowLeadingZeroes: _propTypes.default.bool,
  decimalLimit: _propTypes.default.number,
  currencyType: _propTypes.default.string,
  handleBlur: _propTypes.default.func,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func,
  precision: _propTypes.default.number,
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  editableCurrency: _propTypes.default.oneOfType([_propTypes.default.shape({
    currencyList: _propTypes.default.arrayOf(_propTypes.default.string),
    defaultCurrency: _propTypes.default.string,
    name: _propTypes.default.string
  }), _propTypes.default.bool]),
  currencyList: _propTypes.default.arrayOf(_propTypes.default.string),
  defaultCurrency: _propTypes.default.string,
  /**
   * It provides the regex control given by intervening on the key press.
   * If it complies with the rule, it writes into the input.
   **/
  pattern: _propTypes.default.instanceOf(RegExp),
  handleCurrencyTypeChange: _propTypes.default.func,
  /*
   * If defined as true, onChange returns only 2 parameters.
   * event and its values that appear on the screen as formatted.
   */
  onChangeParamType: _propTypes.default.oneOfType([_propTypes.default.bool]),
  valuePosition: _propTypes.default.oneOf(['left', 'center', 'right']),
  backgroundColorType: _propTypes.default.oneOf(['danger', 'default'])
};
CurrencyInput.defaultProps = {
  decimalSymbol: ',',
  thousandsSeparatorSymbol: '.',
  includeThousandsSeparator: true,
  allowDecimal: true,
  allowLeadingZeroes: true,
  onChangeParamType: false,
  decimalLimit: 2,
  currencyType: 'TL',
  precision: 0,
  valuePosition: 'right'
};
var _default = exports.default = (0, _inputHOC.default)(CurrencyInput);